export const specialDatesRight = [
    { href: "https://www.meucupom.com/cupom-desconto-meucupom-game-day", label: "MeuCupom Game Day" },
    { href: "https://www.meucupom.com/cupom-desconto-brasil-game-day", label: "Brasil Game Day" },
    { href: "https://www.meucupom.com/cupom-desconto-dia-das-criancas", label: "Dia das crianças" },
    { href: "https://www.meucupom.com/cupom-desconto-halloween", label: "Halloween" },
    { href: "https://www.meucupom.com/cupom-desconto-black-friday", label: "Black Friday" },
    { href: "https://www.meucupom.com/cupom-desconto-cyber-monday", label: "Cyber Monday" },
    { href: "https://www.meucupom.com/cupom-desconto-natal", label: "Natal" },
    { href: "https://www.meucupom.com/cupom-desconto-boxing-day", label: "Boxing Day" },
    { href: "https://www.meucupom.com/cupom-desconto-ano-novo", label: "Ano Novo" },
    { href: "https://www.meucupom.com/cupom-desconto-verao", label: "Verão" }
]